// import external modules
import { combineReducers } from "redux";

import { reducer as toastrReducer } from "react-redux-toastr";
import customizer from "./customizer/";
import { reducer as ReducerForm } from "redux-form";
import auth from "./authentication/auth";
import team from "./team/team";
import annees from "./configs/annees";
import categories from "./configs/categories";
import domaines from "./configs/domaines";
import specialites from "./configs/specialites";
import classes from "./classes/classes";
import echeances from "./configs/echeances";
import themes from "./configs/themes";
import programmes from "./classes/programmes";
import enseignants from "./enseignants/enseignants";
import plannings from "./plannings/plannings";
import evaluations from "./evaluations/evaluations";
import etudiants from "./etudiants/etudiants";
import sessions from "./configs/sessions";
import sites from "./configs/sites";
import quiz from "./configs/quiz";
import tasks from "./tasks/tasks";

const rootReducer = combineReducers({
  toastr: toastrReducer, // <- Mounted at toastr.
  customizer: customizer,
  form: ReducerForm,
  auth,
  team,
  annees,
  categories,
  domaines,
  specialites,
  classes,
  echeances,
  themes,
  programmes,
  enseignants,
  plannings,
  evaluations,
  etudiants,
  sessions,
  sites,
  quiz,
  tasks,
});

export default rootReducer;
